import type { SchemesRecord } from '../types';

import { varAlpha } from 'minimal-shared/utils';

import { grey, info, error, common, primary, success, warning, secondary } from './palette';

// ----------------------------------------------------------------------

/**
 * TypeScript extension for MUI theme augmentation.
 * @to {@link file://./../extend-theme-types.d.ts}
 */

export type CustomShadows = {
  z1: string;
  z4: string;
  z8: string;
  z12: string;
  z16: string;
  z20: string;
  z24: string;
  primary: string;
  secondary: string;
  info: string;
  success: string;
  warning: string;
  error: string;
  card: string;
  dialog: string;
  dropdown: string;
};

// ----------------------------------------------------------------------

export function createShadowColor(colorChannel: string): string {
  return `0 12px 28px -10px ${varAlpha(colorChannel, 0.4)}`;
}

function createCustomShadows(colorChannel: string): CustomShadows {
  return {
    z1: `0 2px 6px 0 ${varAlpha(colorChannel, 0.08)}`,
    z4: `0 6px 18px -4px ${varAlpha(colorChannel, 0.1)}`,
    z8: `0 10px 24px -6px ${varAlpha(colorChannel, 0.12)}`,
    z12: `0 12px 32px -8px ${varAlpha(colorChannel, 0.12)}`,
    z16: `0 14px 40px -10px ${varAlpha(colorChannel, 0.12)}`,
    z20: `0 18px 48px -12px ${varAlpha(colorChannel, 0.14)}`,
    z24: `0 22px 56px -14px ${varAlpha(colorChannel, 0.16)}`,
    /********/
    dialog: `0 24px 64px -20px ${varAlpha(common.blackChannel, 0.24)}`,
    card: `0 14px 40px ${varAlpha(common.blackChannel, 0.12)}`,
    dropdown: `0 18px 48px -18px ${varAlpha(common.blackChannel, 0.2)}`,
    /********/
    primary: createShadowColor(primary.mainChannel),
    secondary: createShadowColor(secondary.mainChannel),
    info: createShadowColor(info.mainChannel),
    success: createShadowColor(success.mainChannel),
    warning: createShadowColor(warning.mainChannel),
    error: createShadowColor(error.mainChannel),
  };
}

/* **********************************************************************
 * 📦 Final
 * **********************************************************************/
export const customShadows: SchemesRecord<CustomShadows> = {
  light: createCustomShadows(grey['800Channel']),
  dark: createCustomShadows(common.blackChannel),
};
